module.exports = __webpack_public_path__ + "media/43.6f1a9eae.mp3";